<script lang="ts">
	import { nbspify } from "../../../../core/utils/nbspify";
	import type { CakeProps } from "../../templates/WeddingsProps";
	import StaticPicture from "../Picture/StaticPicture.svelte";

	export let index: number;
	export let item: CakeProps;
</script>

<div class="glide__slide">
	<div class="relative mx-auto h-[13.5rem] !w-[13.5rem] rounded-lg lg:h-[18rem] lg:!w-[18rem]">
		<div
			class="lg:text-md absolute left-4 top-4 flex h-6 w-6 items-center justify-center rounded-full bg-white text-base font-semibold lg:h-8 lg:w-8"
		>
			{index + 1}
		</div>
		<StaticPicture
			class="h-full w-full overflow-hidden rounded-lg"
			image={item.image}
			alt={item.alt ?? "Fotografie – ukázka svatebního dortu"}
			height={360}
			width={288}
			loading="lazy"
		/>
		<p
			class="text-2xs absolute bottom-3 left-3 right-3 w-fit max-w-[calc(100%-(2*.75rem))] whitespace-normal rounded-lg bg-white px-3 py-[.3rem] font-semibold lg:bottom-4 lg:left-4 lg:right-4 lg:max-w-[calc(100%-(2*1rem))] lg:text-base"
		>
			{nbspify(item.desc[0] ?? "")}
		</p>
	</div>
</div>
